<template>
  <div class="wallet-log">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="资金明细">
          <div class="content">
            <div class="wallet-title">资金明细</div>

            <div class="filter-box noSelect">
              <el-input v-model="param.keyword" clearable style="width: 300px" placeholder="查询流水号"/>
              <!--              <el-select v-model="type" placeholder="请选择类型" style="margin-right: 10px;">-->
<!--                <el-option label="类型1" value="0"></el-option>-->
<!--                <el-option label="类型2" value="1"></el-option>-->
<!--                <el-option label="类型3" value="2"></el-option>-->
<!--              </el-select>-->

<!--              <el-date-picker-->
<!--                  v-model="date"-->
<!--                  type="daterange"-->
<!--                  range-separator="至"-->
<!--                  start-placeholder="开始日期"-->
<!--                  end-placeholder="结束日期">-->
<!--              </el-date-picker>-->

              <div class="btn btn1">查询</div>
<!--              <div class="btn btn2">导出表格</div>-->
            </div>

            <el-table
                v-loading="loadingData"
                :data="tableData"
                max-height="600px"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                style="width: 100%">
<!--              <el-table-column prop="id" label="编号" width="120"/>-->
              <el-table-column label="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createtime | timeFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="memo" label="流水号/描述"/>
              <el-table-column prop="money" label="金额" width="100"/>
              <el-table-column prop="after" label="操作后余额" width="100"/>
            </el-table>
            <div class="pages-box">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="param.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="param.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {apiWalletGet} from "@/api/api"

export default {
  name: "walletLog",
  components:{headerNav, userNav, footerBox},
  data(){
    return{
      loadingData: false,
      tableData: [],
      param: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      total: 0,
    }
  },
  filters:{
    timeFilter(time) {
      if (!time) return '—'
      let date = new Date(time * 1000)
      let y = date.getFullYear()
      let m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
      let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      let hh = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      let mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      let ss = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    }
  },
  mounted(){
    this.loadData();
  },
  methods: {
    handleSizeChange(val){
      this.param.limit = val;
      this.loadData();
    },
    handleCurrentChange(val){
      this.param.page = val;
      this.loadData();
    },
    loadData() {
      apiWalletGet(this.param).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    },
  }
}
</script>


<style>
.el-tabs--border-card{
  border: none;
  box-shadow: none;
}
.el-tabs__item{
  padding: 0 60px !important;
}
.el-tabs--border-card>.el-tabs__header{
  background-color: #E4E4E4;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover{
  color: #000000 !important;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  border: none;
}
.el-table td {
  color: #000000;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.wallet-log{
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .user-center{
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main{
      min-height: calc(100vh - 270px);

      .content{
        padding: 20px;

        .wallet-title{
          font-size: 16px;
          font-weight: bold;
          color: #0f375a;
          margin-bottom: 20px;
        }
        .filter-box{
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          .btn{
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            margin-left: 10px;
            cursor: pointer;
          }
          .btn1{
            background-color: #0f375a;
            color: #ffffff;
          }
          .btn2{
            border: 1px solid #0f375a;
            color: #0f375a;
          }

        }

        .pages-box{
          margin-top: 20px;
        }
      }
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/wallet/log.vue